// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__nf4hq","floatingHidden":"styles_floatingHidden__U5YEI"};